
import Vue from "vue";
// import ChangeLanguage from "@/components/shared/ChangeLanguage.vue";

export default Vue.extend({
  name: "AuthBoardingHeader",
  data() {
    return {
      hcms_logo: require("@/assets/logos/Igbhc-logo.png")
    };
  }
});
